import { HateoasResource, Resource } from '@lagoshny/ngx-hateoas-client';

@HateoasResource('client-certificates', { routeName: 'frontdoorResourceRoute' })
export class ClientCertificate extends Resource {
    id: string;
    name: string;
    value: string;
    selected: boolean;
}

